<ng-container *ngIf="bodyParams">
    <div *ngIf="mimeType" class="iframe-block">
        <!-- <div class="iframe-plate">
            <div class="plate-label">
                <div class="plate-label-item" i18n>
                    <span>{{ statusName }}</span>
                </div>
                <div class="plate-label-triangle"></div>
            </div>
        </div> -->
        <ng-container *ngIf="iframeType === 'TXT'">
            <iframe
                *ngIf="url"
                [src]="url"
                class="transparent-iframe"
                allowTransparency="true"
                [toolbar]="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen>
             </iframe>
        </ng-container>
        <ng-container *ngIf="iframeType === 'PDF'">
            <ngx-extended-pdf-viewer
               *ngIf="url"
               [src]="url"
               [height]="'50vh'"
               [showToolbar]="true"
               [showSidebarButton]="true"
               [showFindButton]="false"
               [showPagingButtons]="true"
               [showDrawEditor]="false"
               [showStampEditor]="false"
               [showTextEditor]="false"
               [showZoomButtons]="true"
               [showPresentationModeButton]="true"
               [showOpenFileButton]="false"
               [showPrintButton]="true"
               [showDownloadButton]="false"
               [showSecondaryToolbarButton]="true"
               [showRotateButton]="undefined"
               [showRotateCwButton]="true"
               [showRotateCcwButton]="true"
               [showHandToolButton]="false"
               [showScrollingButtons]="false"
               [showSpreadButton]="true"
               [showPropertiesButton]="true"
               [filenameForDownload]="fileName">
           </ngx-extended-pdf-viewer>
        </ng-container>
    </div>
</ng-container>
